<template>
  <div class="section-home" v-if="!loading">
    <top-bar-layout />
    <router-view class="div-section" />
    <footer-layout />
    <drawer-layout />
  </div>
  <v-overlay v-model="loading" class="overlay-home" persistent>
    <div class="overlay-home">
      <img
      :src="require('@/assets/imgs/svgs/commercia-logo.svg')"
      alt="Commercia Logo">
      <br>
      <v-progress-circular indeterminate size="64" color="#FFFFFF"/>
    </div>
  </v-overlay>
</template>
<script>
import axios from 'axios'
import DrawerLayout from '@/components/layouts/Drawer.vue'
import FooterLayout from '@/components/layouts/Footer.vue'
import TopBarLayout from '@/components/layouts/TopBar.vue'

export default {
  name: 'CommerciaVueHome',
  components: {
    DrawerLayout,
    TopBarLayout,
    FooterLayout
  },
  data () {
    return {
      loading: true
    }
  },
  beforeCreate () {
    this.$store.dispatch('autoLogin')
  },
  created () {
    this.getUser()
  },
  methods: {
    async getUser () {
      axios.get('auth/user', { email: this.email, password: this.password })
        .then(response => {
          return response.data
        }).then(data => {
          this.$store.dispatch('saveUser', data)
          console.log('data.role.name')
          console.log(data.role.name)
          if ((data.role.name === 'admin' || data.role.name === 'manager' || data.role.name === 'finance') && !this.$store.state.business) {
            console.log('entro')
            console.log(data.business._id)

            this.getBusiness(data.business._id)
          }
          this.loading = false
        }).catch(e => { console.log(e) })
    },
    async getBusiness (id) {
      axios.get('business/getById?business=' + id)
        .then(response => {
          return response.data
        }).then(data => {
          this.$store.dispatch('saveBusiness', data)
          this.loading = false
        }).catch(e => { console.log(e) })
    }
  }
}
</script>
<style scoped>
.section-home{
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #F9F6F2;
}
.overlay-home{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
